<!--<div class="col-9  product">-->
<!--    <app-products-grid [searchKeyword]="searchKeyword" [ProductDataSet]="dataset"-->
<!--                       [isSearchGrid]="isSearchGrid"></app-products-grid>-->

<!--</div>-->


<!--<app-product-browser-->
<!--        [ngClass]="{'visible':searchIsActive,'hidden':!searchIsActive}"></app-product-browser>-->


<div class=" overflow-hidden p-4" style="min-height: 500px;">
    <div class="row ">
        <div class="col all">

            <div class="row g-5 ">

<!--                <div class="col-md-3 d-sm-none d-md-block" >-->

<!--                    <div class="m-b-15"></div>-->
<!--                    <div *ngFor="let filter of []">-->


<!--                        &lt;!&ndash;                    <div class="m-t-20">&ndash;&gt;-->
<!--                        &lt;!&ndash;                        <app-product-filter-type-checkbox></app-product-filter-type-checkbox>&ndash;&gt;-->
<!--                        &lt;!&ndash;                    </div>&ndash;&gt;-->

<!--                        &lt;!&ndash;                    <div class="m-t-20">&ndash;&gt;-->
<!--                        &lt;!&ndash;                        <app-product-filter-type-range></app-product-filter-type-range>&ndash;&gt;-->
<!--                        &lt;!&ndash;                    </div>&ndash;&gt;-->

<!--                    </div>-->
<!--                </div>-->
                <div class="col-md-12 col-sm-12  product">
                    <app-products-grid [searchKeyword]="searchKeyword" [ProductDataSet]="dataset"
                                       [isSearchGrid]="isSearchGrid" #gridComponent></app-products-grid>

                </div>
            </div>
        </div>
    </div>
</div>




